import { atom } from "recoil";

export const updateConnectorDrawerState = atom({
  key: "updateConnectorDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
